import _isEmpty from 'lodash/isEmpty';
import buildVehicleObject from './buildVehicleObject.js';
import buildDealerObject from './buildDealerObject.js';
import buildPaymentObject from './buildPaymentObject.js';
import buildTradeObject from './buildTradeObject.js';
const buildShopperObject = user => {
  const shopper = Object.keys(user).reduce((acc, key) => {
    if (user[key] && user[key].length > 0) {
      acc[key] = user[key];
    }
    return acc;
  }, {});
  if (!_isEmpty(shopper)) return shopper;
  return {};
};
async function buildOfferObject(sponsor) {
  let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let paymentsInfo = arguments.length > 2 ? arguments[2] : undefined;
  let walletId = arguments.length > 3 ? arguments[3] : undefined;
  let dealXgId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  let shopperProfile = arguments.length > 5 ? arguments[5] : undefined;
  let listingObj = arguments.length > 6 ? arguments[6] : undefined;
  let listedPrice = arguments.length > 7 ? arguments[7] : undefined;
  let {
    dealerId: mmdId,
    cashDealPrice,
    listing
  } = config;
  const {
    listingPrice,
    chromeStyleId
  } = config;

  // Logic to support loading SDP on find-car on multiple location when uds config is not present.
  if (Object.keys(listingObj).length && listingObj?.paymentServices?.dealerSettings?.mmdId) {
    mmdId = listingObj?.paymentServices?.dealerSettings?.mmdId;
    cashDealPrice = listingObj?.paymentServices?.dealerSettings?.cashDealPrice;
    listing = listingObj;
  }
  const {
    dealType,
    penciling,
    tradeIn,
    icoTradeIn = {}
  } = paymentsInfo || {};
  const fallBackPrice = dealType === 'finance' ? listingPrice + (listing?.pricingDetail?.rebate ?? 0) : listingPrice;
  const {
    msrp,
    salePrice
  } = listing?.pricingDetail || {};
  let finalPrice = penciling?.offerPrice ?? listedPrice;
  if (!listedPrice) {
    finalPrice = penciling?.offerPrice ?? fallBackPrice ?? salePrice ?? msrp;
  }
  const userTradeInData = Object.keys(icoTradeIn).length ? icoTradeIn : tradeIn;
  const trade = !dealXgId ? buildTradeObject(userTradeInData, penciling) : {};
  let offer = !dealXgId && {
    // the listedPrice in vehicle object should be the original listed value instead of the modified one
    dealer: buildDealerObject(mmdId, sponsor),
    payment: buildPaymentObject(paymentsInfo, finalPrice, cashDealPrice),
    shopper: buildShopperObject(shopperProfile),
    vehicle: buildVehicleObject(fallBackPrice ?? salePrice ?? msrp, listing, chromeStyleId),
    walletId
  };
  if (!dealXgId && trade?.value) {
    offer.trade = {
      ...trade,
      isNetTradeAppliedToFinancing: true
    };
  }
  if (dealXgId) {
    offer = {
      dealXgId,
      sponsor
    };
  }
  return offer;
}
export { buildOfferObject as default };
